module.exports = __webpack_public_path__ + "ba4d9e95a17900f846c45d812e55a46b.png";